var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton"},_vm._l((_vm.rows),function(n){return _c('div',{key:n,staticClass:"skeleton__row",style:({ marginBottom: _vm.rowGap })},[(_vm.avatar)?_c('div',{staticClass:"skeleton__avatar",style:(_vm.avatarStyle)}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"skeleton__line",style:(_vm.lineStyle(n - 1))})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }